export type DeliveryProvider = 'uber-eats' | 'glovo'
export type AcceptanceMode = 'MANUAL' | 'AUTOMATIC'
export interface DeliveryConnection {
  provider: 'UBER_EATS' | 'GLOVO'
  externalStoreId: string
  enabled: boolean
  acceptanceMode: AcceptanceMode
}
export interface UberStore {
  id: string
  name: string
  address: string
}
export interface ConnectionSession {
  status: 'waiting' | 'ready' | 'failed' | 'activated'
  stores: UberStore[]
}
export const deliveryConnectionsKey = (
  userId: string | undefined,
  restaurantId: string,
  provider: DeliveryProvider
) => ['delivery-connections', userId, restaurantId, provider] as const

export interface DeliveryConnectionsClient {
  get: (
    restaurantId: string,
    provider: DeliveryProvider,
    signal?: AbortSignal
  ) => Promise<DeliveryConnection | null>
  save: (
    restaurantId: string,
    provider: DeliveryProvider,
    connection: Omit<DeliveryConnection, 'provider'>
  ) => Promise<DeliveryConnection>
  setAcceptanceMode: (
    restaurantId: string,
    acceptanceMode: AcceptanceMode
  ) => Promise<DeliveryConnection>
  capabilities: (restaurantId: string) => Promise<{ oauthAvailable: boolean }>
  start: (
    restaurantId: string
  ) => Promise<{ sessionId: string; authorizationUrl: string }>
  session: (
    restaurantId: string,
    sessionId: string,
    signal?: AbortSignal
  ) => Promise<ConnectionSession>
  cancel: (restaurantId: string, sessionId: string) => Promise<void>
  activate: (
    restaurantId: string,
    sessionId: string,
    storeId: string,
    acceptanceMode: AcceptanceMode
  ) => Promise<{ active: boolean; pending: boolean }>
  verify: (
    restaurantId: string
  ) => Promise<{ active: boolean; pending: boolean }>
  disconnect: (restaurantId: string) => Promise<void>
}
